import { Component, EventEmitter, Output, Input } from '@angular/core';
import { Confirmation } from '../cpi-override-confirmation/types/confirmation';

@Component({
  selector: 'ps-ui-cpi-override-warning',
  templateUrl: './cpi-override-warning.component.html',
  styleUrls: ['./cpi-override-warning.component.css'],
})
export class CpiOverrideWarningComponent {
  @Output()
  public confirm = new EventEmitter<Confirmation>();

  @Input()
  public surveyId: number;

  @Input()
  public newCpi: string;

  public onConfirmation(confirmation: Confirmation): void {
    this.confirm.emit(confirmation);
  }
}
